import axios from 'axios';

import { DefaultError, UseQueryOptions, useQuery } from '@tanstack/react-query';

import { QueryKeys } from './query-keys';

type PollTransactionStatusParams = {
  txid?: string;
  esploraUrl: string | null;
  onConfirmed?: (txInfo: { txid: string }) => void;
};

type PollTransactionStatusResponse = {
  txid: string;
  status: {
    confirmed: boolean;
  };
};

type QueryOptionsParam = Omit<UseQueryOptions<PollTransactionStatusResponse, DefaultError>, 'queryKey' | 'queryFn'>;

export async function fetchTransactionStatus(esploraUrl: string, txid: string) {
  const path = `${esploraUrl}/tx/${txid}`;
  const result = await axios.get(path);

  return result.data;
}

export function usePollTransactionStatus(params: PollTransactionStatusParams, options?: QueryOptionsParam) {
  const { txid, esploraUrl, onConfirmed } = params;

  return useQuery({
    queryKey: [QueryKeys.transaction, txid],
    queryFn: () => fetchTransactionStatus(params.esploraUrl || '', txid || ''),
    refetchInterval: (query) => {
      const data = query.state.data;
      const isConfirmed = data?.status.confirmed;

      if (onConfirmed && data && !!isConfirmed) {
        console.log(`[usePollTransactionStatus] confirmed data:`, data);
        onConfirmed({
          txid: data.txid,
        });
      }

      return isConfirmed ? false : 5000;
    },
    enabled: !!txid && !!esploraUrl,
    ...options,
  });
}
